import React from 'react';
import {
  ChartBarIcon,
  DocumentTextIcon,
  CalendarDaysIcon,
  UserGroupIcon,
  ClockIcon,
  CurrencyPoundIcon
} from '@heroicons/react/24/outline';
import ReportBuilder from '../components/Reports/ReportBuilder';

const EnterpriseReporting = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-white shadow rounded-lg">
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Enterprise Reporting</h1>
              <p className="mt-1 text-sm text-gray-500">
                Comprehensive reporting and analytics with UK compliance focus
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                <ChartBarIcon className="h-3 w-3 mr-1" />
                Advanced Analytics
              </div>
            </div>
          </div>
        </div>

        {/* Report Categories */}
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
            <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg p-4 text-white">
              <div className="flex items-center">
                <ClockIcon className="h-8 w-8 mr-3" />
                <div>
                  <h3 className="text-lg font-semibold">Attendance Reports</h3>
                  <p className="text-sm opacity-90">Time tracking & compliance</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-lg p-4 text-white">
              <div className="flex items-center">
                <CalendarDaysIcon className="h-8 w-8 mr-3" />
                <div>
                  <h3 className="text-lg font-semibold">Scheduling Reports</h3>
                  <p className="text-sm opacity-90">Shift planning & coverage</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-purple-500 to-purple-600 rounded-lg p-4 text-white">
              <div className="flex items-center">
                <CurrencyPoundIcon className="h-8 w-8 mr-3" />
                <div>
                  <h3 className="text-lg font-semibold">Payroll Reports</h3>
                  <p className="text-sm opacity-90">Cost analysis & forecasts</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-lg p-4 text-white">
              <div className="flex items-center">
                <DocumentTextIcon className="h-8 w-8 mr-3" />
                <div>
                  <h3 className="text-lg font-semibold">Compliance Reports</h3>
                  <p className="text-sm opacity-90">UK regulations & audits</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Report Builder Component */}
      <ReportBuilder />

      {/* UK Compliance Info */}
      <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <DocumentTextIcon className="h-5 w-5 text-yellow-400" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-yellow-800">
              UK Compliance Reporting Features
            </h3>
            <div className="mt-2 text-sm text-yellow-700">
              <ul className="list-disc list-inside space-y-1">
                <li><strong>Working Time Regulations:</strong> 48-hour average, daily/weekly rest periods</li>
                <li><strong>National Minimum Wage:</strong> Effective hourly rate calculations and compliance checks</li>
                <li><strong>Statutory Payments:</strong> SSP, SMP, SPP calculations and reporting</li>
                <li><strong>Holiday Pay:</strong> 52-week average calculations for irregular workers</li>
                <li><strong>RTI Reporting:</strong> FPS/EPS export formats for HMRC submission</li>
                <li><strong>Pension Auto-enrolment:</strong> Eligibility tracking and contribution reporting</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnterpriseReporting;